module.exports = __webpack_public_path__ + "static/mailgun-39e545311c6e8a49d7235e720379ab18.jpg";